import React from 'react';

const NotificationPreviewModal = ({ notification, onClose }) => {
    if (!notification) return null;

    return (
        <div className="notif-preview-overlay" onClick={onClose}>
            <div className="notif-preview-modal" onClick={(e) => e.stopPropagation()}>
                <div className="notif-preview-header">
                    <h6 className="notif-preview-title">{notification.title}</h6>
                    <button className="notif-preview-close" onClick={onClose}>&times;</button>
                </div>
                <div className="notif-preview-body">
                    {notification.time && (
                        <div className="notif-preview-time">{notification.time}</div>
                    )}
                    {notification.bodyLoading ? (
                        <p className="notif-preview-message text-muted">Loading…</p>
                    ) : notification.body ? (
                        <div dangerouslySetInnerHTML={{ __html: notification.body }} />
                    ) : (
                        <p className="notif-preview-message">{notification.title}</p>
                    )}
                </div>
            </div>
            <style>
                {`
.notif-preview-modal {
    width: 95vw;
    height: 95vh;
    max-width: none;
    max-height: none;
    border-radius: 8px;
    overflow-y: auto;
}
    `}
            </style>
        </div>
    );
};

export default NotificationPreviewModal;
